import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CookieConsent } from "@/components/CookieConsent";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import Shop from "@/pages/Shop";
import ComingSoon from "@/pages/ComingSoon";
import UserLanding from "@/pages/UserLanding";
import StylistLanding from "@/pages/StylistLanding";
import SalonLanding from "@/pages/SalonLanding";
import InfluencerLanding from "@/pages/InfluencerLanding";
import StylistInvite from "@/pages/StylistInvite";
import PrecisionMethod from "@/pages/PrecisionMethod";
import AdminAnalytics from "@/pages/AdminAnalytics";
import Journal from "@/pages/Journal";
import ArticlePage from "@/pages/ArticlePage";
import AnalyticsTracker from "@/components/AnalyticsTracker";

function App() {
  return (
    <div className="App bg-stylist-bg text-stylist-ink">
      <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminAnalytics />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/consultation" element={<UserLanding />} />
          <Route path="/join-stylist" element={<StylistLanding />} />
          <Route path="/stylist-invite" element={<StylistInvite />} />
          <Route path="/stylist-invite/:handle" element={<StylistInvite />} />
          <Route path="/join-salon" element={<SalonLanding />} />
          <Route path="/how-it-works" element={<PrecisionMethod />} />
          <Route path="/how-it-works/users" element={<UserLanding />} />
          <Route path="/how-it-works/stylists" element={<StylistLanding />} />
          <Route path="/how-it-works/influencers" element={<InfluencerLanding />} />
          <Route path="/influencers" element={<InfluencerLanding />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/journal/:slug" element={<ArticlePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
